/**
 * @generated SignedSource<<1fe03af63514ba34188327b78d3fc768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MobilePhotoContent_photoNode$data = {
  readonly firmName: string | null;
  readonly photo: {
    readonly id: string;
    readonly path: string | null;
    readonly photoLike: {
      readonly photoLikeId?: string | null;
      readonly totalPhotoLikes: number | null;
    } | null;
    readonly serviceId: string | null;
    readonly url: string | null;
  } | null;
  readonly projectName: string | null;
  readonly projectUrl: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FirmDetailsWrapper_photoNode" | "PhotoDetailsWrapper_photoNode" | "PhotoSwiperWrapper_photoNode">;
  readonly " $fragmentType": "MobilePhotoContent_photoNode";
};
export type MobilePhotoContent_photoNode$key = {
  readonly " $data"?: MobilePhotoContent_photoNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"MobilePhotoContent_photoNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobilePhotoContent_photoNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotoSwiperWrapper_photoNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotoDetailsWrapper_photoNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FirmDetailsWrapper_photoNode"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firmName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhoto",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotoLike",
          "kind": "LinkedField",
          "name": "photoLike",
          "plural": false,
          "selections": [
            {
              "condition": "hasUserId",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "photoLikeId",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalPhotoLikes",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhotosQueryOutput",
  "abstractKey": null
};

(node as any).hash = "c32937cda3b584a85616fcfddfa58182";

export default node;
